import React, { useEffect, useState } from "react";
import { Navbar, Button, Image, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FaPhoneAlt, FaWhatsapp } from "react-icons/fa";
import "./Header.css";

function Header() {
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const onScroll = () => setIsSticky(window.scrollY > 8);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const callNumber = "+33972119472";
  const waNumber = "237677200200";

  const openWhatsApp = () => {
    window.open(`https://wa.me/${waNumber}`, "_blank", "noopener,noreferrer");
  };

  return (
    <Navbar
      expand="lg"
      className={`border-bottom app-navbar topbar ${
        isSticky ? "is-sticky" : ""
      }`}
      aria-label="Barre d'en-tête"
      style={{
        position: "sticky",
        top: 0,
        ...(isSticky && { borderBottom: "1px solid #dcdcdc" }),
      }}
    >
      <Container className="d-flex justify-content-between align-items-center">
        <Navbar.Brand as={Link} to="/" className="brand">
          <Image
            src="/images/logo-Cplatform.png"
            alt="Platform98"
            width={200}
            height={55}
            className="brand-logo"
          />
        </Navbar.Brand>

        <div className="nav-actions">
          <Button
            type="button"
            className="btn-orange phone-cta"
            onClick={openWhatsApp}
            aria-label="Contacter par téléphone ou WhatsApp"
          >
            <FaPhoneAlt size={18} className="phone-cta-icon" />
            <span className="phone-text">
              {callNumber} / <FaWhatsapp size={20} className="wa-cta-icon" /> +
              {waNumber}
            </span>
          </Button>
        </div>
      </Container>
    </Navbar>
  );
}

export default Header;
